import {
    Button,
    List,
    Space,
    message,
    Modal,
    Form,
    Input,
    InputNumber,
    Select,
    Popconfirm,
    Col,
    Row,
    Divider,
    Tag, Spin
} from "antd";
import { NAIRA } from "../../defaults/utilities";
import {useState, useRef, useEffect} from "react";
import { EditOutlined, CheckOutlined, CloseCircleOutlined, SendOutlined, DeleteOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { formatCurrency } from "../../helpers/currency";
import DataTable from "../common/table";
import {
    useApproveBudget,
    useDeleteBudget,
    useDeleteProjection,
    useDownloadBudgetReport, useDownloadProjectionReport,
    useRejectBudget,
    useSubmitForApproval,
    useUpdateBudget
} from "../../hooks/budget/budgetQuery";
import { userStore } from "../../store/userStore";
import { useFetchAllFinancialYears } from "../../hooks/financialYear/financialYearQuery";
import { useGetAlltBudgetItems } from "../../hooks/budgetItem/budgetItemQuery";
import { useDepartments } from "../../hooks/department/departmentQuery";
import {useGetAllLevels} from "../../hooks/payrollData/payrollDataQuery";
import {useGetAllDesignation} from "../../hooks/designation/designationQuery";
import {useFetchAllStaffCategories} from "../../hooks/staffcategory/staffCategoryQuery";
import CreateProjectionComponent from "./createProjectionComponent";
import UploadRecord from "./uploadRecords";
import {NewProjectionEntry, ProjectionEntries} from "./projeprojectionEntries";



const { Option } = Select;


export default function PreviewProjection({ item, handleModalClose, updateItem }) {
    const [editOpen, setEditOpen] = useState(false);
    const [currItem, setCurrItem] = useState({});
    const [currItems, setCurrItems] = useState([...item?.staffProjectionItems]);
    const [year, setYear] = useState(item.financialYear.id);
    const [total, setTotal] = useState(0);
    const [itemState, setItemState] = useState(item)
    const [department, setDepartment] = useState(item?.office?.id);
    const [downloading, setDownloading] = useState(false)


    const titleRef = useRef(null)

    const approve = useApproveBudget();
    const reject = useRejectBudget();
    const submit = useSubmitForApproval();

    const deleteProjection = useDeleteProjection();

    const downloadBudgetReport = useDownloadProjectionReport();



    let AUTHORIZED_SCOPE = "";

    const user = userStore(state => state.user);

    const { years } = useFetchAllFinancialYears();

    // switch (item.budgetScope.toLowerCase()) {
    //     case "unit":
    //         AUTHORIZED_SCOPE = "HEAD_OF_UNIT";
    //         break;
    //
    //     case "department":
    //         AUTHORIZED_SCOPE = "HEAD_OF_DEPARTMENT";
    //         break;
    //     default:
    //         break;
    // }

    const handleOpen = () => {
        handleModalClose();
        setEditOpen(true);
    }
    const handleClose = () => setEditOpen(false);


    const downloadReport = async (combined) => {
        setDownloading(true)
        const d = await downloadBudgetReport(department, year)
        setDownloading(false)
    }

    function removeItem(id) {
        const item = currItems.find((_, itemIndex) => itemIndex === id);
        setTotal(prevTotal => prevTotal -= +(item.amount));
        setCurrItems((prevItems) => (prevItems.filter((_, idx) => idx !== id)))
    }

    function editItem(id) {
        const item = currItems.find((_, itemIndex) => itemIndex === id);
        removeItem(id)
        // add to edit
        document.getElementById("btnAdd").click()
        setCurrItem(...item)
    }

    function addItem(callback1, callback2) {
        // setCurrItem((prev)=>({...prev,id:index}));
        setCurrItems((prev) => {
            return [...prev, currItem]
        });
        setTotal(prevTotal => prevTotal += +(currItem.amount));
        setCurrItem({});
        callback1()
        callback2();
        // index++;
    }

    const approveBudget = async () => {
        const response = await approve(item.id)
        message.success('Projection Approved Successfully');
        updateItem(response)
        handleModalClose();
    }

    const rejectBudget = async () => {
        const response = await reject(item.id);
        message.success('Projection rejected successfully');
        updateItem(response)
        handleModalClose();
    }

    const submitForApproval = async () => {
        const response = await submit(item.id)
        message.success('Projection Submitted Successfully');
        updateItem(response)
        handleModalClose();
    }


    const handleDeleteBudget = async () => {
        const { message: response } = await deleteProjection(item.id);
        handleModalClose();
        message.success(response ?? "Projection deleted successfully");
        return;
    }
    return (
        <>
            <div style={{ marginTop: "3em", maxHeight: "70vh", overflowY: "scroll", paddingLeft: "2em", paddingRight: "2em" }}>

                <div style={{ padding: "1em" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span>Budget Title:</span>
                        <span style={{ fontWeight: "bold" }}>{item?.title}</span>
                    </div>
                    <Divider style={{ marginTop: "5px", marginBottom: "5px" }} />
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span>Financial Year:</span>
                        <span style={{ fontWeight: "bold" }}>{item.financialYear?.title}</span>
                    </div>
                    <Divider style={{ marginTop: "5px", marginBottom: "5px" }} />
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span>Office:</span>
                        <span style={{ fontWeight: "bold" }}>{item.office?.title}</span>
                    </div>
                    <Divider style={{ marginTop: "5px", marginBottom: "5px" }} />
                    <span>Projection Breakdown:</span>
                    <List
                        bordered
                        style={{ marginBottom: '2em', }}
                        itemLayout="vertical"
                        dataSource={item.staffProjectionItems}
                        renderItem={(it, idx) => (
                            <>
                                {
                                    idx === 0 &&
                                    <List.Item key={Math.random()}>
                                        <div className="buget-item-list" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            fontWeight: "bold"
                                        }}>
                                            <div style={{width: '15%'}}>
                                                {/*<span style={{fontWeight: 'bold', marginRight: '5px'}}></span>*/}
                                                Level
                                            </div>
                                            <div style={{textAlign: 'left', width: '15%'}}>
                                                Design.
                                            </div>
                                            <div style={{textAlign: 'left', width: '15%'}}>
                                                Category
                                            </div>
                                            <div style={{textAlign: 'right', width: '10%'}}>
                                                Current
                                            </div>
                                            <div style={{textAlign: 'right', width: '10%'}}>
                                                Proposed
                                            </div>
                                            <div style={{textAlign: 'right', width: '10%'}}>
                                                Exhausted
                                            </div>
                                            <div style={{textAlign: 'left', width: '15%', marginLeft: '5px'}}>
                                                Amount
                                            </div>
                                            <div style={{textAlign: 'left', width: '10%', marginRight: '10px'}}>
                                                Actions
                                            </div>
                                        </div>
                                    </List.Item>
                                }
                                <List.Item key={it.id}>
                                    <div className="buget-item-list" style={{
                                        display: 'flex',
                                        justifyContent: 'space-evenly',
                                    }}>
                                        <div style={{width: '15%'}}>
                                            <span style={{fontWeight: 'bold', marginRight: '2px'}}>{idx + 1}. </span>
                                            {it?.level?.title}
                                        </div>
                                        <div style={{textAlign: 'left', width: '15%'}}>
                                            {it?.designation?.title}
                                        </div>
                                        <div style={{textAlign: 'left', width: '15%'}}>
                                            {it?.staffCategory?.title}
                                        </div>
                                        <div style={{textAlign: 'right', width: '10%'}}>
                                            {it?.noInPost}
                                        </div>
                                        <div style={{textAlign: 'right', width: '10%'}}>
                                            {it?.noProposed}
                                        </div>
                                        <div style={{textAlign: 'right', width: '10%'}}>
                                            {it?.noExhausted}
                                        </div>
                                        <div style={{textAlign: 'left', width: '15%', marginLeft: '10px'}}>
                                            {NAIRA}{formatCurrency(it.totalAmount)}
                                        </div>
                                        <div style={{textAlign: 'left', width: '10%', marginRight: '10px'}}>
                                            {
                                                item.submitted && <Space>
                                                    <ProjectionEntries item={it}/>
                                                    <NewProjectionEntry projectionItem={it} onUpdate={() => {
                                                    }}/>
                                                </Space>
                                            }
                                        </div>
                                    </div>
                                </List.Item>
                                {
                                    (idx === (item.staffProjectionItems.length - 1)) &&
                                    <List.Item key={Math.random()}>
                                        <div className="buget-item-list" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                        }}>
                                            <div style={{width: '75%'}}>
                                                <span style={{fontWeight: 'bold', marginRight: '5px'}}>Totals </span>

                                            </div>
                                            <div style={{textAlign: 'left', width: '15%'}}>
                                                {NAIRA}{formatCurrency(item.staffProjectionItems.map(b => b.totalAmount).reduce((i, c) => i + c, 0))}
                                            </div>
                                            <div style={{textAlign: 'right', width: '10%', marginRight: '10px'}}>

                                            </div>
                                        </div>
                                    </List.Item>
                                }
                            </>
                        )}
                    />
                </div>
                <div style={{display: 'flex', justifyContent: 'flex-start', marginTop: "1em" }}>
                    <Space direction="horizaontal" wrap align="center">
                        {
                            user.id === item.createdBy.id && (
                                <>
                                    <Button type='primary' onClick={() => handleOpen()} disabled={item.submitted}>
                                        <EditOutlined />
                                        Edit
                                    </Button>
                                    <Popconfirm
                                        title="Delete this budget item"
                                        description="Are you sure to delete this projection?"
                                        onConfirm={handleDeleteBudget}
                                        onCancel={() => null}
                                        okText="Yes"
                                        cancelText="No"
                                        disabled={item.submitted}
                                    >
                                        <Button type="primary" danger disabled={item.submitted}>
                                            <DeleteOutlined />
                                            Delete
                                        </Button>
                                    </Popconfirm>
                                    {
                                        !item.submitted &&
                                        <Button type='primary' style={{ backgroundColor: 'green' }} onClick={() => submitForApproval()}>
                                            <CheckOutlined />
                                            Submit
                                        </Button>
                                    }
                                </>
                            )
                        }
                        {
                            (item.submitted && !item.finalApproved && user.roles?.includes(item.nextApprovalStage?.role)) &&
                            <>
                                <Button type='primary' style={{ backgroundColor: 'green' }} onClick={() => approveBudget()}>
                                    <CheckOutlined />
                                    Approve
                                </Button>
                                <Button type='primary' style={{ backgroundColor: "orange" }} onClick={() => rejectBudget()}>
                                    <CloseCircleOutlined />
                                    Reject
                                </Button>
                            </>
                        }

                        <div>
                            <Button loading={downloading} onClick={downloadReport} style={{ backgroundColor: "green", color: "#FFFFFF" }} >
                                Download Report
                            </Button>
                        </div>
                    </Space>
                </div>
            </div>
            <Modal
                centered
                title="Update Budget Item"
                open={editOpen}
                footer={null}
                onCancel={handleClose}
                width={"75vw"}
            >
                <CreateProjectionComponent projection={item} toggleOpen={() => handleClose()} />
            </Modal>
            {/*<Modal*/}
            {/*    centered*/}
            {/*    title="Upload budgets"*/}
            {/*    open={fileUpload}*/}
            {/*    footer={null}*/}
            {/*    onCancel={toggleUploadModal}*/}
            {/*    width={"50vw"}*/}
            {/*>*/}
            {/*    <UploadRecord onUpload={toggleUploadModal} />*/}
            {/*</Modal>*/}
        </>
    )
}
